import { gql } from '@apollo/client';

const ERRORS = `errors { path, message }`;

const EVENT_CORE_FIELDS = gql`
  fragment EventCoreFields on Event {
    id
    eventAt
    timeType
    notes
    amount
    duration
    durationDescription
    createdAt
    updatedAt
  }
`;

export const EVENT_FIELDS = gql`
  ${EVENT_CORE_FIELDS}
  fragment EventFields on Event {
    ...EventCoreFields
    client { id, name }
    eventType { id, name, amountLabel }
    medicineGroup { id, name }
    medicines { id, name, emoji, doseAmount, doseType }
    providers { id, name, emoji }
    things { id, name, emoji }
  }
`;

export const EVENT = gql`
  ${EVENT_FIELDS}
  query Event($id: ID!) {
    event(id: $id) {
      ...EventFields
      eventMedicines {
        id
        medicine { id, name }
        notes
      }
      eventProviders {
        id
        provider { id, name }
        notes
      }
      eventThings {
        id
        thing { id, name }
        notes
      }
    }
  }
`;

export const EVENTS = gql`
  ${EVENT_FIELDS}
  query Events (
    $limit: Int!
    $offset: String!
    $options: ConnectionOptionsInput!
  ) {
    events (
      first: $limit
      after: $offset
      options: $options
    ) {
      edges {
        cursor
        node {
          ...EventFields
        }
      }
      totalCount
    }
  }
`;

export const CREATE_EVENT = gql`
  ${EVENT_CORE_FIELDS}
  mutation CreateEvent ($input: CreateEventInput!) {
    createEvent (input: $input) {
      event {
        ...EventCoreFields
      }
      ${ERRORS}
    }
  }
`;

export const UPDATE_EVENT = gql`
  ${EVENT_CORE_FIELDS}
  mutation UpdateEvent ($input: UpdateEventInput!) {
    updateEvent (input: $input) {
      event {
        ...EventCoreFields
      }
      ${ERRORS}
    }
  }
`;

export const DESTROY_EVENT = gql`
  mutation DestroyEvent ($input: DestroyEventInput!) {
    destroyEvent (input: $input) {
      ${ERRORS}
    }
  }
`;

export const EVENT_SELECTS = gql`
  query EventSelects {
    clients (
      first: 999999
      after: "MA=="
      options: {}
    ) {
      edges {
        node {
          id
          name
          userDefault
        }
      }
    }
    eventTypes (
      first: 999999
      after: "MA=="
      options: {}
    ) {
      edges {
        node {
          id
          name
          emoji
          hasAmount
          amountLabel
          hasDuration
          hasMedicines
          hasProviders
          hasThings
        }
      }
    }
    medicineGroups (
      first: 999999
      after: "MA=="
      options: {}
    ) {
      edges {
        node {
          id
          name
          scheduledTime
          client { id }
          medicines { id, name, emoji }
        }
      }
    }
  }
`;

export const EVENT_COUNTS_BY_DAY = gql`
  query EventCountsByDay (
    $eventTypeId: ID!
  ) {
    eventCountsByDay (
      eventTypeId: $eventTypeId
    ) {
      date
      count
    }
  }
`;
